import { setCookie, getCookie, getRequestProtocol } from 'h3'

function isHexAddress(v) {
  return typeof v === 'string' && /^0x[a-fA-F0-9]{40}$/.test(v.trim())
}

export default defineNuxtRouteMiddleware((to) => {
  const cfg = useRuntimeConfig().public
  const queryKey = cfg.affiliateQueryParam || 'affiliate'
  const cookieKey = cfg.affiliateCookieKey || 'cnclr_affiliate_address'

  const hasCookie = process.server
    ? (() => {
        const ev = useRequestEvent()
        return ev ? Boolean(getCookie(ev, cookieKey)) : false
      })()
    : document.cookie.split('; ').some(r => r.startsWith(cookieKey + '='))

  const raw = to.query?.[queryKey]
  const val = Array.isArray(raw) ? raw[0] : raw
  const affiliate = typeof val === 'string' ? val.trim() : ''

  if (hasCookie) {
    if (affiliate) {
      const q = { ...to.query }
      delete q[queryKey]
      return navigateTo({ path: to.path, query: q }, { replace: true })
    }
    return
  }

  if (!isHexAddress(affiliate)) return

  const maxAge = 60 * 60 * 24 * 90

  if (process.server) {
    const ev = useRequestEvent()
    if (ev) {
      const secure = getRequestProtocol(ev) === 'https'
      setCookie(ev, cookieKey, affiliate, {
        domain: cfg.rootDomain || undefined,
        path: '/',
        sameSite: 'lax',
        secure,
        httpOnly: false,
        maxAge
      })
    }
  } else {
    const parts = [
      `${cookieKey}=${encodeURIComponent(affiliate)}`,
      'Path=/',
      `Max-Age=${maxAge}`,
      'SameSite=Lax'
    ]
    if (location.protocol === 'https:') parts.push('Secure')
    if (cfg.rootDomain) parts.push(`Domain=${cfg.rootDomain}`)
    document.cookie = parts.join('; ')
  }

  const q = { ...to.query }
  delete q[queryKey]
  return navigateTo({ path: to.path, query: q }, { replace: true })
})
